export default __webpack_public_path__ + "static/media/prime.0563c23e.png";